import { Injectable } from "@angular/core";
import { AngularFireRemoteConfig } from "@angular/fire/remote-config";
import { BackendService } from "@toro/common/shared/services/new-http/backend.service";
import { Observable } from "rxjs";
import { IDepositExecutionDate } from "../../interfaces/deposit-execution-date.interface";
import { IGeneratePixCode } from "../../interfaces/generate-pix-code.interface";

export class PixDepositPayload {
  constructor(
    public cblc: string,
    public cpf: string,
    public value: number
  ) {}
}

@Injectable({ providedIn: "root" })
export class PixDepositService {
  private pixUrl = "/virtualfinance/pix/qr-code";
  private getExecutionDateUrl =
    "/virtualfinance/finance/deposit-execution-date";
  private initPromise: Promise<void> | null = null;

  constructor(
    private remoteConfig: AngularFireRemoteConfig,
    private backendService: BackendService
  ) {}

  private ensureRemoteConfigReady(): Promise<void> {
    if (!this.initPromise) {
      this.initPromise = this.remoteConfig
        .ensureInitialized()
        .then(() => this.remoteConfig.fetchAndActivate())
        .then(() => undefined)
        .catch((error) => {
          console.error('[PixDepositService] Remote Config initialization failed:', error);
          this.initPromise = null;
        });
    }
    return this.initPromise;
  }

  public getPixCode(
    payload: PixDepositPayload
  ): Observable<IGeneratePixCode> {
    return this.backendService.api.post(this.pixUrl, payload);
  }

  public getDepositExecutionDate(): Observable<IDepositExecutionDate> {
    return this.backendService.api.get(this.getExecutionDateUrl);
  }

  /**
   * Get deposit remote config feature flag boolean value.
   * Awaits initialization before reading the activated value.
   */
  public async getValueByKey(key: string): Promise<boolean> {
    try {
      await this.ensureRemoteConfigReady();
      return await this.remoteConfig.getBoolean(key);
    } catch (error) {
      console.error(`[PixDepositService] Failed to get key "${key}":`, error);
      return false;
    }
  }

  public getDepositByPixEnabled(): Promise<boolean> {
    return this.getValueByKey("depositByPixEnabled");
  }
}
